<template>
    <v-card>
        <new-partner
        v-if="add_partner_com"
        v-on:save_partner_success="save_partner_success"
        v-on:save_partner_error="save_partner_error"
        v-on:scanner="scanner"
        v-on:close_partner="close_partner"
        ></new-partner>

      <v-card-text>
          <v-data-table
              :headers="headers"
              :items="partners"
              :search="search"
              :loading="loading"
              class="elevation-1"
           
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
          >
              <template v-slot:top>
                  <v-toolbar flat>
                      <v-toolbar-title>Партнеры</v-toolbar-title>
                      <v-divider
                          class="mx-4"
                          inset
                          vertical
                      ></v-divider>
                      <v-btn
                       color="primary"
                       @click="add_partner_com = true"
                       dark
                       class="mb-2">
                          Добавить
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Поиск"
                          single-line
                          hide-details
                      ></v-text-field>
                  </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="edit_partner(item)">
                      mdi-pencil
                  </v-icon>
              </template>
              <template v-slot:no-data>
                  <v-btn color="primary"  text @click="get_partners">
                      Загрузить
                  </v-btn>
              </template>
          </v-data-table>



          <v-dialog
          v-model="edit_partner_dialog"
          max-width="400"
          @click:outside="close_add_partner"
        >
          <v-card>
            <v-card-title class="text-h5">
              Редактирование партнера
            </v-card-title>

            <v-card-text>
              <v-text-field
                  v-model="partner.nom"
                  label="Имя"
                  required
                  :rules="nameRules"
              ></v-text-field>

              <v-text-field
              v-model="partner.tel"
              label="Телефон"
              :rules="phoneRules"
              ></v-text-field>


                  <v-text-field
                  v-model="partner.hash_karta"
                  label="Номер бонусной карты"
                  :rules="[v => !!v || 'Введите номер бонусной карты']"
                  ></v-text-field>

                  <v-switch
                  v-model="partner.holat"
                  :label="partner.holat ==1 ? 'Активный' : 'Не активный'"
                ></v-switch>

            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="error darken-1"
                text
                @click="close_add_partner"
              >
                Отмена
              </v-btn>

              <v-btn
                color="green darken-1"
                text
                @click="change_partner"
                :loading="loading"
                :disabled="partner.hash_karta == '' || partner.nom == '' || partner.tel == ''"
              >
                Изменить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

          <v-snackbar
          v-model="snack"
          :timeout="3000"
          :color="snackColor"
        >
          {{ snackText }}

          <template v-slot:action="{ attrs }">
            <v-btn
              v-bind="attrs"
              text
              @click="snack = false"
            >
              Закрыть
            </v-btn>
          </template>
        </v-snackbar>

      </v-card-text>
    </v-card>
  </template>

  <script>
  export default {

      data: () => ({

          snack: false,
          snackColor: '',
          snackText: '',
          add_partner_com: false,

          search: '',
          loading: false,


          phoneRules: [
              v => !!v || 'Поле обязательно для заполнения',
              v=> (v && v.length >= 9) || 'Номер должен быть не менее 9 символов',
              v => (v && /^\d+$/.test(v)) || 'Неверный формат номера телефона',
              v => (v && v.length == 9) || 'Неверный формат номера телефона',

          ],

          nameRules: [
              v => !!v || 'Поле обязательно для заполнения',
              v=> (v && v.length >= 3) || 'Название должно быть не менее 3 символов',

          ],

          headers: [
              {
                  text: '№',
                  align: 'start',
                  sortable: false,
                  value: 'id_partner',
              },
              { text: 'Имя', value: 'nom' },
              { text: 'Телефон', value: 'tel' },
              { text: 'Действия', value: 'actions', sortable: false },
          ],
          partners: [],
          partner: {},
          edit_partner_dialog: false,

      }),

      mounted() {
          this.get_partners();
      },
      methods: {

          get_partners() {
              this.loading = true;
              axios.get('/api/get_partners',
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;
                                  this.partners = response.data.partners;
                              }else{
                                  this.loading = false;
                                  this.snack = true
                                  this.snackColor = 'error'
                                  this.snackText = "Ошибка получения клиентов"
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                              }
                          })
                          .catch(error => {
                              this.loading = false;
                              this.snack = true
                              this.snackColor = 'error'
                              this.snackText = error.response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                          });
          },

          save_partner_success(){
              this.add_partner_com = false;
              this.get_partners();
              this.snack = true
              this.snackColor = 'success'
              this.snackText = "Партнёр успешно сохранен"
          },
          save_partner_error(){
              this.add_partner_com = false;
              this.snack = true
              this.snackColor = 'error'
              this.snackText = "Ошибка сохранения партнёра"
          },
          close_partner(){
              this.add_partner_com = false;
          },

          edit_partner(item){
              this.edit_partner_dialog = true;
              this.partner = item;
          },

          change_partner(){


                 this.loading = true;
              axios.post('/api/change_partner', this.partner,
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;
                                  this.edit_partner_dialog = false;
                                  this.snack = true
                                  this.snackColor = 'success'
                                  this.snackText = "Партнёр успешно изменен"

                                  this.close_add_partner();
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);

                              }else{
                                  this.loading = false;
                                  this.snack = true
                                  this.snackColor = 'error'
                                  this.snackText = "Ошибка изменения партнёра"
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                              }
                          })
                          .catch(error => {
                              this.loading = false;
                              this.snack = true
                              this.snackColor = 'error'
                              this.snackText = error.response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                          });



          },



          close_add_partner(){
              this.edit_partner_dialog = false;
              this.partner = {};
              this.get_partners();
          },





      }
  }
  </script>

  <style>

  </style>






